const { formatMoney } = window.BAO.Utils

class BuildYourOwnBundle extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.maxProducts = parseInt(this.dataset.maxProducts)
    this.forms = this.els.form.elements
    this.counters = this.els.count.elements
    this.progressBars = this.els.progressBar.elements
    this.priceElements = this.els.price.elements
    this.renderBundleCart = this.renderBundleCart.bind(this)
    this.submitBundleCart = this.submitBundleCart.bind(this)
    this.countProductsPerCollection = this.countProductsPerCollection.bind(this)

    this.collectionId = this.dataset.collectionId

    const params = new URLSearchParams(window.location.search)
    let uuid = params.get('uuid')

    if (uuid === null || uuid === undefined) {
      uuid = crypto.randomUUID()
      const currentUrl = new URL(window.location.href)
      currentUrl.searchParams.set('uuid', uuid)
      window.history.replaceState({}, '', currentUrl)
    }

    this.uuid = uuid
    this.products = []

    const storedProducts = JSON.parse(localStorage.getItem(`${this.collectionId}-${this.uuid}`))
    if (storedProducts !== null && storedProducts !== undefined) {
      storedProducts.forEach((product) => {
        this.addProductToBundleCart(product[3], product[0], product[1], product[2])
      })
      this.renderBundleCart(true)
    }
  }

  setupListeners () {
    this.mobileBundleDrawerToggle()

    this.els.addToBundleButton.elements.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.dataset.drawerByobVariantSelectExternalEl === 'trigger') {
          return
        }

        this.addProductToBundleCart(event.target.closest('.byob-ProductGrid').dataset.productListId, event.target.dataset.productId, parseFloat(event.target.dataset.productPrice), event.target.dataset.productHandle)
      })
    })

    document.body.addEventListener('click', (event) => {
      if (event.target.dataset.byobProductAdd === undefined) return

      if (event.target.dataset.removeId != null && event.target.dataset.removePrice != null) {
        this.removeProductFromBundleCart(event.target.dataset.removeId, event.target.dataset.removePrice)
      }

      this.addProductToBundleCart(event.target.dataset.collectionGridId, event.target.dataset.productId, parseFloat(event.target.dataset.productPrice), event.target.dataset.productHandle)
    })

    const loadMoreButtons = this.els.loadMoreButton?.elements
    if (loadMoreButtons?.length > 0) {
      loadMoreButtons.forEach((loadMoreButton) => {
        loadMoreButton.addEventListener('click', () => {
          this.loadMoreButtons(event.target)
        })
      })
    }

    const formSubmits = this.els.formSubmit.elements
    formSubmits.forEach((formSubmit) => {
      formSubmit.addEventListener('click', (e) => {
        e.preventDefault()
        this.submitBundleCart()
      })
    })

    this.updateQuickLinks()
  }

  async renderBundleCart (resetCart) {
    const products = this.products
    const byobCarts = this.els.bundleItemsContainer.elements

    if (resetCart) {
      byobCarts.forEach((byobCart) => {
        byobCart.querySelectorAll('[data-byob-product-container]').forEach((container) => {
          container.innerHTML = ''
          container.setAttribute('data-empty', 'true')
        })
      })
    }

    let count = 0
    for (const product of products) {
      const url = `/products/${product[2]}?section_id=byob-item&variant=${product[0]}`
      const response = await fetch(url)
      const html = await response.text()

      byobCarts.forEach((byobCart) => {
        const currentItems = byobCart.querySelectorAll('[data-byob-product-container]:not([data-empty])').length
        const cartItem = byobCart.querySelector('[data-byob-product-container][data-empty]')

        if (cartItem && count >= currentItems) {
          cartItem.innerHTML = html
          cartItem.removeAttribute('data-empty')
          cartItem.setAttribute('data-collection-id', product[3])
        }
      })
      count += 1
    }
    localStorage.setItem(`${this.collectionId}-${this.uuid}`, JSON.stringify(this.products))

    this.querySelectorAll("[data-byob-item-el='removeButton']").forEach((button) => {
      button.addEventListener('click', (e) => {
        e.stopImmediatePropagation()
        this.removeProductFromBundleCart(event.target.parentElement.dataset.productId, parseFloat(event.target.parentElement.dataset.price))
      })
    })

    const bundleComplete = this.products.length >= this.dataset.minimumProducts

    const formSubmits = this.els.formSubmit.elements
    formSubmits.forEach((formSubmit) => {
      formSubmit.disabled = !bundleComplete
    })

    this.countProductsPerCollection()
  }

  addProductToBundleCart (collectionGrid, productId, price, productHandle) {
    const productCount = this.forms[0].querySelectorAll('[data-form-product]').length
    if (productCount >= this.maxProducts) return

    this.forms.forEach((form) => {
      const index = form.querySelectorAll('[data-form-product]').length

      const productInputs = document.createElement('div')
      productInputs.setAttribute('data-form-product-id', productId)

      const idInput = document.createElement('input')
      idInput.type = 'hidden'
      idInput.name = `items[${index}][id]`
      idInput.value = productId
      idInput.setAttribute('data-form-product', '')
      productInputs.appendChild(idInput)

      const quantityInput = document.createElement('input')
      quantityInput.type = 'hidden'
      quantityInput.name = `items[${index}][quantity]`
      quantityInput.value = '1'
      productInputs.appendChild(quantityInput)

      const collectionInput = document.createElement('input')
      collectionInput.type = 'hidden'
      collectionInput.name = `items[${index}][properties][_bundle_collection_id]`
      collectionInput.value = this.dataset.collectionId
      productInputs.appendChild(collectionInput)

      const groupInput = document.createElement('input')
      groupInput.type = 'hidden'
      groupInput.name = `items[${index}][properties][_bundle_group_id]`
      groupInput.value = this.uuid
      productInputs.appendChild(groupInput)

      form.appendChild(productInputs)
    })

    this.products.push([productId, price, productHandle, collectionGrid])

    this.renderBundleCart(false)
    this.updateBundleQuantity()
    this.updateBundlePrice(true, price)

    const drawer = this.els.mobileDrawer.element
    drawer.setAttribute('data-open', true)

    window.drawers.activeDrawerKey = ''
    if (window.innerWidth < 768) {
      document.body.classList.add('util-SiteOverflowed')
    }

    if (!event) return
    const currentText = event.target.textContent
    const addedText = event.target.dataset.addedText
    const textElement = event.target.querySelector('[data-add-to-bundle-text]')

    if (textElement) {
      textElement.textContent = addedText
      setTimeout(() => {
        textElement.textContent = currentText
      }, 1000)
    }
  }

  removeProductFromBundleCart (productId, price) {
    for (let i = 0; i < this.products.length; i++) {
      if (this.products[i][0] === productId) {
        this.products.splice(i, 1)
        break
      }
    }

    this.querySelector(`[data-form-product-id='${productId}']`).remove()
    this.reindexFormProducts()
    this.renderBundleCart(true)
    this.updateBundleQuantity()
    this.updateBundlePrice(false, price)
  }

  countProductsPerCollection () {
    this.els.productGridList.elements.forEach((collection) => {
      const collectionId = collection.dataset.productListId
      const count = this.products.filter((product) => product[3] === collectionId).length

      const collectionCounter = collection.querySelector('[data-build-your-own-bundle-el="collectionLimit"] .byob-CollectionLimit_Selected')

      if (collectionCounter != null && count != null) {
        collectionCounter.textContent = count

        const max = collection.querySelector('[data-build-your-own-bundle-el="collectionLimit"]').dataset.collectionLimit

        if (max != null) {
          if (count >= max) {
            this.disableProductsInCollection(collectionId)
          } else {
            this.enableProductsInCollection(collectionId)
          }
        }
      }
    })
  }

  disableProductsInCollection (collectionId) {
    const products = document.querySelectorAll(`[data-product-list-id="${collectionId}"] .byob-ProductGrid_Item`)
    products.forEach((product) => {
      product.setAttribute('data-disabled', 'true')
    })
  }

  enableProductsInCollection (collectionId) {
    const products = document.querySelectorAll(`[data-product-list-id="${collectionId}"] .byob-ProductGrid_Item`)
    products.forEach((product) => {
      product.setAttribute('data-disabled', 'false')
    })
  }

  reindexFormProducts () {
    this.forms.forEach((form) => {
      const productGroups = form.querySelectorAll('[data-form-product-id]')
      productGroups.forEach((group, index) => {
        group.querySelectorAll('input').forEach((input) => {
          input.name = input.name.replace(/items\[\d+\]/, `items[${index}]`)
        })
      })
    })
  }

  updateBundleQuantity () {
    const productCount = this.forms[0].querySelectorAll('[data-form-product]').length

    this.counters.forEach((el) => {
      el.textContent = productCount
    })
    this.updateProgressBars(productCount)
  }

  updateProgressBars (productCount) {
    this.discount = 0
    this.progressBars.forEach((bar) => {
      const progress = (productCount / this.maxProducts) * 100
      bar.style.setProperty('--progress', `${progress}%`)

      const milestones = bar.querySelectorAll('[data-threshold-passed]')
      milestones.forEach((milestone) => {
        const threshold = parseInt(milestone.dataset.threshold)

        if (productCount >= threshold) {
          milestone.dataset.thresholdPassed = 'true'
          this.discount = 1 - parseFloat(milestone.dataset.discount / 100)
        } else {
          milestone.dataset.thresholdPassed = 'false'
        }
      })

      const titles = bar.parentElement.querySelectorAll('[data-progress-bar-title]')
      if (titles.length === 0) return
      let activeTitle = bar.parentElement.querySelector('[data-active="true"]').innerText

      titles.forEach((title) => {
        const threshold = parseInt(title.dataset.threshold)
        if (productCount >= threshold) {
          activeTitle = title
        }
      })

      titles.forEach((title) => {
        if (title === activeTitle) {
          title.setAttribute('data-active', 'true')
        } else {
          title.setAttribute('data-active', 'false')
        }
      })
    })
  }

  updateQuickLinks () {
    window.addEventListener('scroll', () => {
      const scrollPosition = window.scrollY || document.documentElement.scrollTop
      if (scrollPosition === 0) {
        this.els.quickLink.elements.forEach((link) => {
          link.setAttribute('data-disabled', 'true')
        })
      } else {
        this.els.quickLink.elements.forEach((link) => {
          link.setAttribute('data-disabled', 'false')
        })
      }
    })

    const productGridLists = this.els.productGridList.elements
    productGridLists.forEach((list) => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const listId = entry.target.dataset.productListId
            this.els.quickLink.elements.forEach((link) => {
              if (link.dataset.productListId === listId) {
                link.setAttribute('data-active', 'true')
              } else {
                link.setAttribute('data-active', 'false')
              }
            })
          }
        })
      }, { threshold: 0.5 })

      observer.observe(list)
    })
  }

  loadMoreButtons (loadMoreButton) {
    const productGrid = loadMoreButton.parentElement.parentElement.querySelector('[data-capped]')
    productGrid.dataset.capped = productGrid.dataset.capped === 'true' ? 'false' : 'true'

    if (productGrid.dataset.capped === 'false') {
      loadMoreButton.textContent = loadMoreButton.dataset.showLess
    } else {
      loadMoreButton.textContent = loadMoreButton.dataset.showMore
      productGrid.scrollIntoView({ behavior: 'smooth', block: 'end' })
    }
  }

  updateBundlePrice (increase, price) {
    this.priceElements.forEach((priceElement) => {
      let priceTotal = priceElement.dataset.currentPrice ? parseFloat(priceElement.dataset.currentPrice) : 0

      if (increase) {
        priceTotal += price
      } else {
        priceTotal -= price
      }

      if (this.discount > 0) {
        priceElement.querySelector('[data-price]').innerText = formatMoney(priceTotal * this.discount)
        priceElement.querySelector('[data-compare-at-price]').innerText = formatMoney(priceTotal)
      } else {
        priceElement.querySelector('[data-price]').innerText = formatMoney(priceTotal)
        priceElement.querySelector('[data-compare-at-price]').innerText = ''
      }

      priceElement.dataset.currentPrice = priceTotal
      priceElement.dataset.priceReady = this.totalPrice > 0 ? 'false' : 'true'
    })
  }

  async submitBundleCart () {
    const currentCart = await window.BAO.Cart.getCart()

    for (const item of currentCart.items) {
      if (item.properties['_bundle_group_id'] === this.uuid) {
        await window.BAO.Cart.removeItem(item.key)
      }
    }

    const drawer = this.els.mobileDrawer.element
    drawer.setAttribute('data-open', false)
    document.body.classList.toggle('util-SiteOverflowed', false)

    const form = document.querySelector('[data-build-your-own-bundle-el="form"]')
    return window.BAO.Cart.addItemFromForm(form)
  }

  mobileBundleDrawerToggle () {
    const drawerTrigger = this.els.mobileTrigger.element
    const drawer = this.els.mobileDrawer.element

    drawerTrigger.addEventListener('click', () => {
      const isOpen = drawer.getAttribute('data-open') === 'true'
      drawer.setAttribute('data-open', !isOpen)

      document.body.classList.toggle('util-SiteOverflowed', !isOpen)
    })
  }
}

if (!customElements.get('build-your-own-bundle')) {
  customElements.define('build-your-own-bundle', BuildYourOwnBundle)
}
